import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export type CallsListRowSkeletonProps = {
  className?: string
}

export function CallsListRowSkeleton({ className }: CallsListRowSkeletonProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-2 rounded-md border px-3 py-2',
        className,
      )}
      aria-hidden
    >
      <Skeleton className="h-4 w-28 font-mono" />
      <Skeleton className="h-5 w-16 rounded-md" />
      <Skeleton className="h-3 w-24" />
    </div>
  )
}

export type CallsListSkeletonProps = {
  count?: number
  ariaLabel?: string
  className?: string
}

export function CallsListSkeleton({
  count = 5,
  ariaLabel = 'Loading calls',
  className,
}: CallsListSkeletonProps) {
  return (
    <div
      className={cn('space-y-2', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      {Array.from({ length: count }).map((_, index) => (
        <CallsListRowSkeleton key={index} />
      ))}
    </div>
  )
}
